import { NavigationProvider, useModal } from "@/contexts";
import {
    LOCAL_STORAGE,
    useNewNavigate,
    useSetBookingRecoilState,
    useSetBookingYeogiRecoilState,
    useSetToggleState,
    useSetVimeoState,
} from "@/shared/client";
import { useGetBaseInfo, useGetIntro, type BaseInfoResponse, type IntroResponse } from "@/shared/server";
import { insertGoogleAnalytics } from "@/utils";
import { Center, Spinner } from "@chakra-ui/react";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Outlet, useLocation } from "react-router-dom";
import { Footer } from "./footer";
import { Header } from "./header";
import { Intro } from "./intro";

export const Layout = () => {
    const { data: introData, isLoading } = useGetIntro<IntroResponse>();
    const { data } = useGetBaseInfo<BaseInfoResponse>();
    const { isPrivate, logoUrl, navigation, pensionInfo, ga, bookingUrl, ybs, yeogi, vimeo } = { ...data };
    const { pathname } = useLocation();
    const { onNavigate } = useNewNavigate();
    const { closeModal } = useModal();
    const setToggleState = useSetToggleState();
    const setBookingEngineState = useSetBookingRecoilState();
    const setBookingYeogi = useSetBookingYeogiRecoilState();
    const setVimeoState = useSetVimeoState();

    useEffect(() => {
        window.scrollTo(0, 0);
        setToggleState(false);
        closeModal();

        if (pensionInfo) {
            if (ga?.head) insertGoogleAnalytics(ga);
            LOCAL_STORAGE.set({ key: "pensionName", value: `${pensionInfo.name.kr}` });

            if (bookingUrl) {
                const isGoogleBE = bookingUrl.includes("booking-engine");
                setBookingEngineState({ isGoogleBE, bookingUrl });
            }
            if (yeogi) {
                setBookingYeogi(yeogi);
            }
        }
        if (vimeo) {
            setVimeoState(vimeo);
        }
    }, [pathname, ga]);

    const navigationData = {
        navigation: {
            roomList: data?.navigation.roomList || [],
            specialList: data?.navigation.specialList || [],
        },
    };

    const excludedPaths = ["/home", "location", "/about", "/specials", "/rooms", "/reserve", "/guide"];

    const shouldShowIntro =
        introData?.result.isIntro === true && !excludedPaths.some((path) => pathname.includes(path));
    useEffect(() => {
        if (introData) {
            if (!introData.result.isIntro) onNavigate({ path: "/home" });
        }
    }, [introData]);

    return !isLoading ? (
        <>
            <Helmet>
                <title>{pensionInfo?.name.kr}</title>
            </Helmet>
            {shouldShowIntro ? (
                <Intro IntroGroup={introData.result.IntroGroup} />
            ) : (
                <>
                    <Header navigation={navigation} logoUrl={logoUrl} pensionInfo={pensionInfo} />
                    <NavigationProvider value={navigationData}>
                        <Outlet />
                    </NavigationProvider>
                    <Footer isPrivate={isPrivate} logoUrl={logoUrl} pensionInfo={pensionInfo} ybs={ybs} yeogi={yeogi} />
                </>
            )}
        </>
    ) : (
        <Center h="100dvh">
            <Spinner />
        </Center>
    );
};
